import TimelinePointDetails from "@/features/Timeline/TimelinePointDetails";

export default class TimelinePoint {
    sourceID: string = ""; // ID of the scorecard or other thing that caused the event
    timestampUTC: Date = new Date();
    value: number | null = null;
    type: TimelinePointType = TimelinePointType.Scorecard;
    published: boolean = false;
    details: TimelinePointDetails = new TimelinePointDetails();
}

// This must be synced with TimelinePoint.cs on the backend.
export enum TimelinePointType {
    Scorecard,
    Section,
    Question,
    Incident,
    SupplierEvent,
}
